// extracted by mini-css-extract-plugin
export default {"previews":"DisplayFile_previews__LvvfK","previewCard":"DisplayFile_previewCard__t1TKe"};